<template lang="html">
  <modal class="select-modal"
    :name="modalName"
    height="auto"
    :adaptive="true"
    top="120"
    width="416"
    :maxWidth="416"
    @before-open="beforeOpen"
    @closed="closed"
    @opened="opened"
  >
    <div class="modal-container">
      <div class="modal-header bold">
        {{attribute}}
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <SelectableList
          :options="options"
          @update-option="updateOption"
        />
        <div class="gap-1x" v-if="showOtherInput" />
        <input v-if="showOtherInput" v-model="otherInput" />
      </div>
      <div class="line-break-gray" />
      <ModalFooter
        :cancel="hide"
        :save="save"
      />
    </div>
  </modal>
</template>

<script>
import _ from 'lodash'

import DisableBodyScroll from 'src/mixins/DisableBodyScroll.js'
import ModalFooter from 'src/components/common/modals/shares/ModalFooter.vue'
import SelectableList from 'src/components/common/form/SelectableList.vue'

export default {
  components: { SelectableList, ModalFooter },
  mixins: [DisableBodyScroll],
  computed: {
    showOtherInput() {
      return this.otherOption && this.otherOption.selected;
    },
    otherOption() {
      return this.options[this.options.length - 1]
    },
    optionsText() {
      return _.map(this.options, 'text')
    },
    selectedOptions() {
      var options = _.map(
        _.filter(this.options, (o) => { return o.selected && o.text != 'Other' }),
      'text')
      if (this.otherOption.selected) {
        return options.concat(this.otherInput)
      }

      return options;
    }
  },
  methods: {
    beforeOpen(event) {
      this.setOptionsData(event.params.name)
      // console.log(event.params)
      this.errors = {};
      this.otherInput = _.find(event.params.selectedOptions, (option) => { return this.optionsText.indexOf(option) == -1 })
      _.each(this.options, (option) => {
        option.selected = event.params.selectedOptions.indexOf(option.text) > -1
        if (option.text == 'Other') {
          option.selected = this.otherInput != null
        }
      })
    },
    setOptionsData(name) {
      this.attribute = name
      switch (name) {
        case 'Exterior':
          this.options = [
            { text: "Fiber cement siding", selected: false },
            { text: "Fiber cement panel", selected: false },
            { text: "Wood siding", selected: false },
            { text: "Wood shingles", selected: false },
            { text: "Standing-seam metal", selected: false },
            { text: "Corrugated metal", selected: false },
            { text: "Flat metal panel", selected: false },
            { text: "Aluminum siding", selected: false },
            { text: "Aluminum shingles", selected: false },
            { text: "Engineered wood panels", selected: false },
            { text: "Ceramic tile", selected: false },
            { text: "Bitumin membrane", selected: false },
            { text: "Asphalt shingle", selected: false },
            { text: "Stucco", selected: false },
            { text: "Solar panels", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        case 'Window & Door Frames':
          this.options = [
            { text: "Vinyl", selected: false },
            { text: "Aluminum", selected: false },
            { text: "Wood", selected: false },
            { text: "Steel", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        case 'General Interior':
          this.options = [
            { text: "Painted drywall", selected: false },
            { text: "Plaster walls", selected: false },
            { text: "Wood panel", selected: false },
            { text: "Wood boards", selected: false },
            { text: "Engineered wall board", selected: false },
            { text: "Stone tile flooring", selected: false },
            { text: "Ceramic tile flooring", selected: false },
            { text: "Hardwood flooring", selected: false },
            { text: "Softwood flooring", selected: false },
            { text: "Engineered hardwood flooring", selected: false },
            { text: "Engineered softwood flooring", selected: false },
            { text: "Carpet flooring", selected: false },
            { text: "Laminate flooring", selected: false },
            { text: "Sheet vinyl flooring", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        case 'Kitchen':
          this.options = [
            { text: "Stone countertop", selected: false },
            { text: "Engineered stone countertop", selected: false },
            { text: "Butcher block countertop", selected: false },
            { text: "Tile countertop", selected: false },
            { text: "Stainless steel countertop", selected: false },
            { text: "Stone tile flooring", selected: false },
            { text: "Ceramic tile flooring", selected: false },
            { text: "Hardwood flooring", selected: false },
            { text: "Softwood flooring", selected: false },
            { text: "Engineered flooring", selected: false },
            { text: "Laminate flooring", selected: false },
            { text: "Sheet vinyl", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        case 'Bathroom':
          this.options = [
            { text: "Stone countertop", selected: false },
            { text: "Engineered stone countertop", selected: false },
            { text: "Butcher block countertop", selected: false },
            { text: "Tile countertop", selected: false },
            { text: "Stainless steel countertop", selected: false },
            { text: "Stone tile flooring", selected: false },
            { text: "Ceramic tile flooring", selected: false },
            { text: "Hardwood flooring", selected: false },
            { text: "Softwood flooring", selected: false },
            { text: "Engineered flooring", selected: false },
            { text: "Laminate flooring", selected: false },
            { text: "Sheet vinyl", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        case 'Included Appliances':
          this.options = [
            { text: "Dishwasher", selected: false },
            { text: "Washer", selected: false },
            { text: "Dryer", selected: false },
            { text: "Refrigerator", selected: false },
            { text: "Gas cooktop", selected: false },
            { text: "Electric cooktop", selected: false },
            { text: "Induction cooktop", selected: false },
            { text: "Range & oven", selected: false },
            { text: "Wall oven", selected: false },
            { text: "Microwave", selected: false },
            { text: "Hood", selected: false },
            { text: "Garbage disposal", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        case 'Includes':
          this.options = [
            { text: "Building", selected: false },
            { text: "Foundation", selected: false },
            { text: "Utility connections", selected: false },
            { text: "Landscaping", selected: false },
            { text: "Deck", selected: false },
            { text: "Architecture blueprints", selected: false },
            { text: "Engineering blueprints", selected: false },
            { text: "Contractor coordination", selected: false },
            { text: "City coordination", selected: false },
            { text: "Permit costs", selected: false },
            { text: "Other", selected: false },
          ]
          break;
        default:
          break;
      }
    },
    updateOption(option) {
      _.find(this.options, (o) => { return o.text == option.text }).selected = option.selected
    },
    save() {
      // console.log(this.selectedOptions)
      this.$emit('save', {
        selectedOptions: this.selectedOptions,
        attribute: this.attribute,
      })
      this.$modal.hide(this.modalName)
    },
    hide() {
      this.$modal.hide(this.modalName)
    }
  },
  data() {
    return {
      modalName: 'select-modal',
      options: [],
      otherInput: null,
      errors: {},
      attribute: null
    }
  },
}
</script>
<style lang="scss">
.select-modal {
  .modal-body {
    padding: 20px 24px 12px 24px !important;
  }
}
</style>
